import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import styled from '@emotion/styled';

import BackToJobListButton from '../../../components/BackToJobListButton/BackToJobListButton';
import PageBanner from '../../../components/Banner/PageBanner';
import PaginationControl from '../../../components/PaginationControl/PaginationControl';
import { BOOKMARKS } from '../../../routes/routeConstants';
import JobInfo from './JobInfo/JobInfo';
import JobSearchForm from './JobSearchForm/JobSearchForm';
import JobsList from './JobsList/JobsList';
import useGetLocumJobs from '../../../hooks/dashboard/jobs/useGetLocumJobs';
import { useAppSelector } from '../../../redux/store';
import Page from '../../../components/Page/Page';

const LocumJobs = () => {
  const navigate = useNavigate();

  const [showMobileInfo, setShowMobileInfo] = useState<boolean>(false);
  // Local pagination state
  const [currentPage, setCurrentPage] = useState<number>(1);
  const perPage = 9;

  // Get the data fetching hook and Redux loading state
  const { getLocumJobs, loading } = useGetLocumJobs();
  // Read totalPages from Redux (set by the useGetLocumJobs hook)
  const { totalPages } = useAppSelector((state) => state.locumJobs);

  const [keyword, setKeyword] = useState('');

  // Fetch jobs whenever currentPage or perPage changes.
  useEffect(() => {
    getLocumJobs({
      page: currentPage.toString(),
      perPage: perPage.toString(),
      keyword,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, perPage]);

  // Handler for PaginationControl
  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
    if (typeof window !== 'undefined' && window.innerWidth < 885) {
      setShowMobileInfo(false);
    }
  };

  return (
    <Page title="Locumspace | Jobs">
      <Shell>
        <PageBanner
          label="Job Feeds"
          description="Here are your job feeds"
          className={`onlyMobileScreens ${showMobileInfo ? 'hide' : ''}`}
        />
        <JobSearchForm
          showMobileInfo={showMobileInfo}
          keyword={keyword}
          setKeyword={setKeyword}
        />
        <NavArea>
          <BackToJobListButton
            showMobileInfo={showMobileInfo}
            setShowMobileInfo={setShowMobileInfo}
          />
          <GoToBookmark onClick={() => navigate(`/${BOOKMARKS}`)}>
            Go to Bookmarks
          </GoToBookmark>
        </NavArea>
        <Container>
          <JobViewArea>
            <JobsList
              showMobileInfo={showMobileInfo}
              setShowMobileInfo={setShowMobileInfo}
              loading={loading}
              reset={currentPage}
            />
            <JobInfo showMobileInfo={showMobileInfo} reset={currentPage} />
          </JobViewArea>
          <PaginationShell>
            <PaginationControl
              endPage={totalPages > 0 ? totalPages : 1}
              changePage={handlePageChange}
              defaultNumOfPagination={5}
            />
          </PaginationShell>
        </Container>
      </Shell>
    </Page>
  );
};

export default LocumJobs;

const Shell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  /* margin-top: 32px; */
  margin-bottom: 54px;

  @media (max-width: 884px) {
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  background-color: ${({ theme }) => theme.palette.backgroundColor};
  padding: 2rem;
  border-radius: 0.75rem;

  @media (max-width: 540px) {
    /* border: 1px solid yellow; */
    padding: 20px;
    border-radius: 0;
    // background-color: white;
    background-color: ${({ theme }) => theme.palette.backgroundColor};
    margin-left: -20px;
    margin-right: -20px;
  }

  @media (max-width: 480px) {
    overflow: hidden;
  }
`;

const JobViewArea = styled.div`
  display: grid;
  grid-template-columns: 316px 1fr;
  gap: 32px;
  height: fit-content;

  @media (max-width: 884px) {
    grid-template-columns: 1fr;
  }
`;

const PaginationShell = styled.div`
  display: grid;
  place-content: center;
  grid-column: span 2;

  @media (max-width: 884px) {
  }
`;

const NavArea = styled.div`
  display: flex;
  margin-top: 20px;
`;

const GoToBookmark = styled.div`
  /* border: 1px solid red; */
  margin-left: auto;
  font-weight: 500;
  font-size: 18px;
  font-weight: 500;
  color: #2f80ed;
  cursor: pointer;

  @media (min-width: 885px) {
    display: none;
  }
`;
